import type { Component } from 'vue'
import { CursorIcon } from '@solar-icons/vue/linear'
import { NAV_ITEMS } from '../../shell/AppSidebar/nav-items'

export type ContextKind = 'section' | 'post' | 'document' | 'insight' | 'design'

export interface ContextItem {
  id: string
  label: string
  kind: ContextKind
  /** The first words of the attached passage; shown in quotes after the title, in full in a tooltip. */
  excerpt?: string
  /** An item chip that cannot be removed: the thing a dock panel is open on. The screen chip is always locked. */
  locked?: boolean
}

function navRowIcon(id: string): Component {
  for (const group of NAV_ITEMS) {
    const row = group.rows.find((candidate) => candidate.id === id)
    if (row) return row.icon
  }
  throw new Error(`No nav row "${id}"`)
}

/** The screen chip is always the pointer; an item takes the icon of the nav row it lives in. */
export const CONTEXT_KIND_ICONS: Record<ContextKind, Component> = {
  section: CursorIcon,
  post: navRowIcon('calendar'),
  document: navRowIcon('documents'),
  insight: navRowIcon('visibility'),
  design: navRowIcon('media'),
}

const EXCERPT_LEAD_WORDS = 6

/** The first words of a passage, with an ellipsis when more follows; the caller wraps it in quotes. */
export function excerptLead(excerpt: string): string {
  const words = excerpt.trim().split(/\s+/)
  const lead = words.slice(0, EXCERPT_LEAD_WORDS).join(' ')
  return words.length > EXCERPT_LEAD_WORDS ? `${lead}…` : lead
}
